import React from "react";

const Company = () => {
    return (
        <>
            <div>
                {/* Experience list */}
                <div className=" ">
                    <div className="   mt-10">
                        <h3 className=" text-3xl font-bold text-gray-400">
                            {" "}
                            Job ( Foraneos World from Colombia )
                        </h3>
                        <div className=" flex flex-col gap-4 mt-4 ml-4">
                            <div>
                                <span className="font-bold text-lg text-gray-400">
                                    Role:
                                </span>{" "}
                                Blockchain Developer
                            </div>
                            <div className=" ">
                                <span className="font-bold text-lg text-gray-400">
                                    Location :
                                </span>{" "}
                                Remote
                            </div>
                            <div>
                                <span className="font-bold text-lg text-gray-400">
                                    Duration :
                                </span>{" "}
                                9 month
                            </div>
                            <div>
                                <span className="font-bold text-lg text-gray-400">
                                    Tech Stack :
                                </span>{" "}
                                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-green-400 border border-green-400">
                                    Solidity
                                </span>{" "}
                                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-indigo-400 border border-indigo-400">
                                    Ethereum
                                </span>{" "}
                                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-gray-400 border border-gray-500">
                                    ERC_20
                                </span>{" "}
                            </div>
                            <div>
                                <h4 className=" font-bold text-lg text-gray-400">
                                    Responsibilities and Achievements
                                </h4>
                                <p>
                                    <ul className=" list-disc p-5 pt-2">
                                        <li>
                                            Developed and implemented an ERC-20
                                            token contract in Solidity for
                                            Foraneos World, featuring
                                            transaction fees for sustainable
                                            operation.{" "}
                                        </li>
                                        <li>
                                            Identified and specified a limited
                                            set of tax-free addresses within the
                                            token contract{" "}
                                        </li>
                                        <li>
                                            Authored and deployed a swap
                                            contract enabling users to exchange
                                            Polygon tokens for FRN Tokens.{" "}
                                        </li>
                                        <li>
                                            Successfully executed and tested
                                            both contracts, ensuring
                                            functionality, security, and
                                            reliability.
                                        </li>
                                    </ul>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className=" ">
                <div className="   mt-10">
                    <h3 className=" text-3xl font-bold text-gray-400">
                        {" "}
                        Internship ( World Blockchain Developer from North
                        America )
                    </h3>
                    <div className=" flex flex-col gap-4 mt-4 ml-4">
                        <div>
                            <span className="font-bold text-lg text-gray-400">
                                Role:
                            </span>{" "}
                            Implemented CryptoAPI and Enhanced Frontend with
                            Next.js and Tailwind CSS
                        </div>
                        <div className=" ">
                            <span className="font-bold text-lg text-gray-400">
                                Location :
                            </span>{" "}
                            Remote
                        </div>
                        <div>
                            <span className="font-bold text-lg text-gray-400">
                                Duration :
                            </span>{" "}
                            3 month
                        </div>
                        <div>
                            <span className="font-bold text-lg">
                                Tech Stack :
                            </span>{" "}
                            <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-gray-400 border border-gray-400">
                                Next_js
                            </span>{" "}
                            <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-yellow-400 border border-yellow-400">
                                JavaScript
                            </span>{" "}
                            <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-blue-400 border border-blue-500">
                                Tailwind_css
                            </span>{" "}
                            <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-red-400 border border-red-400">
                                Git
                            </span>{" "}
                            <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-green-400 border border-green-400">
                                Crypto_API
                            </span>{" "}
                            <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-gray-300 border border-gray-300">
                                Express_js
                            </span>{" "}
                        </div>
                        <div>
                            <h4 className=" font-bold text-lg text-gray-400">
                                Responsibilities and Achievements
                            </h4>
                            <p>
                                <ul className=" list-disc p-5 pt-2">
                                    <li>
                                        Implemented CryptoAPI to enhance
                                        cryptocurrency-related functionalities
                                        within the project.{" "}
                                    </li>
                                    <li>
                                        improvement of the frontend using
                                        Next.js and Tailwind CSS for a more
                                        user-friendly and visually appealing
                                        interface.{" "}
                                    </li>
                                    <li>
                                        Collaborated with the frontend
                                        development team to optimize and refine
                                        the user experience.{" "}
                                    </li>
                                </ul>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className=" ">
                <div className="   mt-10">
                    <h3 className=" text-3xl font-bold text-gray-400">
                        {" "}
                        Internship ( SWS Connects from India )
                    </h3>
                    <div className=" flex flex-col gap-4 mt-4 ml-4">
                        <div>
                            <span className="font-bold text-lg text-gray-400">
                                Role:
                            </span>{" "}
                            Sales and Marketing Intern
                        </div>
                        <div className=" ">
                            <span className="font-bold text-lg text-gray-400">
                                Location :
                            </span>{" "}
                            Remote
                        </div>
                        <div>
                            <span className="font-bold text-lg text-gray-400">
                                Duration :
                            </span>{" "}
                            7 month
                        </div>
                        <div>
                            <span className="font-bold text-lg text-gray-400">
                                Tech Stack :
                            </span>{" "}
                            <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-blue-400 border border-blue-400">
                                Sales
                            </span>{" "}
                            <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-indigo-400 border border-indigo-400">
                                Marketing
                            </span>{" "}
                            <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-cyan-400 border border-cyan-400">
                                Graphic_Design
                            </span>{" "}
                        </div>
                        <div>
                            <h4 className=" font-bold text-lg text-gray-400">
                                Responsibilities and Achievements
                            </h4>
                            <p>
                                <ul className=" list-disc p-5 pt-2">
                                    <li>
                                        Interned in sales and marketing at SWS
                                        Connects, actively engaging in client
                                        confirmation and communication.{" "}
                                    </li>
                                    <li>
                                        Conducted client calls to confirm
                                        services, answer queries, and address
                                        concerns.{" "}
                                    </li>
                                    <li>
                                        Generated invoices for client
                                        transactions and maintained accurate
                                        financial records.{" "}
                                    </li>
                                    <li>
                                        Managed social media presence by
                                        creating engaging posts for Facebook and
                                        Instagram to enhance brand visibility.
                                    </li>
                                    <li>
                                        Gained valuable insights into sales and
                                        marketing processes, contributing to the
                                        overall success of the team
                                    </li>
                                </ul>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Company;
